import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const ERP = () => {
  return (
    <main>

      {/* 🔥 HERO */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(15,30,50,0.85), rgba(15,30,50,0.95)), url('https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "110px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>
            ERP Solutions & Business Automation
          </h1>
          <p style={{ maxWidth: "720px", margin: "auto" }}>
            Streamline operations, improve efficiency, and manage your entire business
            from a single integrated system.
          </p>
        </Container>
      </section>

      {/* 🔹 INTRO */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Manage Everything in One System</h2>
              <p>
                Our ERP solutions help organizations integrate all core business
                functions including finance, HR, inventory, and operations into
                a unified platform.
              </p>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Centralized data management",
                  "Automated workflows",
                  "Real-time reporting",
                  "Improved productivity"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg"
                alt="erp"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 MODULES */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">ERP Modules We Offer</h2>

          <Row className="g-4">

            {[
              {
                title: "Finance & Accounting",
                desc: "Manage billing, invoicing, expenses, and financial reporting."
              },
              {
                title: "Human Resource (HR)",
                desc: "Employee management, payroll, attendance, and performance."
              },
              {
                title: "Inventory Management",
                desc: "Track stock, orders, and supply chain operations."
              },
              {
                title: "Sales & CRM",
                desc: "Manage leads, sales pipeline, and customer relationships."
              },
              {
                title: "Project Management",
                desc: "Track tasks, teams, and project progress efficiently."
              },
              {
                title: "Custom Modules",
                desc: "Tailored ERP features based on your business needs."
              }
            ].map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="gov-card p-4 h-100">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 PROCESS */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85)), url('https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <h2 className="text-center mb-5">Our Implementation Approach</h2>

          <Row className="g-4 text-center">
            {[
              "Requirement Analysis",
              "System Design",
              "Module Development",
              "Integration",
              "Testing & Training",
              "Deployment & Support"
            ].map((step, i) => (
              <Col md={4} key={i}>
                <Card className="p-4 bg-dark text-white border-0 h-100">
                  <h5>Step {i + 1}</h5>
                  <p>{step}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* 🔹 BENEFITS */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Key Benefits</h2>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Improved business efficiency",
                  "Reduced manual errors",
                  "Better decision-making with data",
                  "Real-time insights",
                  "Scalable for future growth",
                  "Cost-effective operations"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3183153/pexels-photo-3183153.jpeg"
                alt="erp benefits"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 WHY IGT */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Why Choose IGT ERP Solutions?</h2>

          <Row className="g-4">

            {[
              "Custom-built ERP tailored to your business",
              "Scalable architecture",
              "Secure and reliable systems",
              "Easy-to-use interface",
              "Integration with existing systems",
              "Complete training and support"
            ].map((item, i) => (
              <Col md={4} key={i}>
                <Card className="gov-card p-4 text-center h-100">
                  <p>{item}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Looking for ERP Implementation?</h2>
          <p>Let’s build a system that simplifies your entire business.</p>

          <Button href="/contact" size="lg" variant="light">
            Get Consultation
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default ERP;